module.exports = __webpack_public_path__ + "static/media/Luvilla - Logo.6eebe2e1.svg";